import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'

const RecordNotFound = ({
    icon = '/img/folder.svg',
    heading = 'No Record Found',
    subheading = '',
    reminder,
    cssClass,
}) => {
    const isMdUp = useMediaQuery({ query: '(max-width: 768px)' })

    return (
        <main
            className={classNames(
                'flex flex-grow items-center py-20 justify-center',
                cssClass
            )}
        >
            <div className="container mx-auto px-4 lg:px-8 text-center">
                <div className="flex justify-center mb-4">
                    <img
                        src={icon}
                        alt="Not found"
                        className="h-14 w-auto opacity-30"
                    />
                </div>
                <div className="flex flex-col gap-[2px]">
                    <h1
                        className={`${
                            isMdUp ? 'text-xl' : 'text-2xl'
                        } font-semibold text-[#111927] `}
                    >
                        {heading}
                    </h1>
                    <h1 className={`text-base  font-normal text-[#6C737F]`}>
                        {subheading}
                    </h1>
                    {reminder && (
                        <h1
                            className={`text-xs font-500 text-custom-gradient `}
                        >
                            <span className="font-semibold text-custom-gradient mr-[2px]">
                                Reminder:
                            </span>
                            {reminder}
                        </h1>
                    )}
                </div>
            </div>
        </main>
    )
}

export default RecordNotFound
